import { useMutation } from "react-query";
import { UserManagePayload } from "./interfaces";
import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";

export function useAddClaim(onSuccess: () => void) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationFn: async (newClaim: UserManagePayload) => {
      try {
        return await apiContext.accountApis.addClaim(newClaim.email, newClaim.claims[0]);
      } catch (error: unknown) {
        if (error instanceof Response) {
          const errorMessage = await error.text();
          throw new Error(errorMessage);
        }
        throw new Error("Error in adding claims");
      }
    },
    onSuccess: onSuccess,
  });
}
